var _rect, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoster(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    transform: "translate(0 0.269043)",
    fill: "#DD723A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4375 21.0192H12.7291C13.1086 21.0192 13.4166 20.7112 13.4166 20.3317V18.04C13.4166 17.6605 13.1086 17.3525 12.7291 17.3525H10.4375C10.058 17.3525 9.75 17.6605 9.75 18.04V20.3317C9.75 20.7112 10.058 21.0192 10.4375 21.0192Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4375 26.5192H12.7291C13.1086 26.5192 13.4166 26.2112 13.4166 25.8317V23.54C13.4166 23.1605 13.1086 22.8525 12.7291 22.8525H10.4375C10.058 22.8525 9.75 23.1605 9.75 23.54V25.8317C9.75 26.2112 10.058 26.5192 10.4375 26.5192Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8542 21.0192H19.146C19.5255 21.0192 19.8335 20.7112 19.8335 20.3317V18.04C19.8335 17.6605 19.5255 17.3525 19.146 17.3525H16.8542C16.4747 17.3525 16.1667 17.6605 16.1667 18.04V20.3317C16.1667 20.7112 16.4747 21.0192 16.8542 21.0192Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8542 26.5192H19.146C19.5255 26.5192 19.8335 26.2112 19.8335 25.8317V23.54C19.8335 23.1605 19.5255 22.8525 19.146 22.8525H16.8542C16.4747 22.8525 16.1667 23.1605 16.1667 23.54V25.8317C16.1667 26.2112 16.4747 26.5192 16.8542 26.5192Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2708 21.0192H25.5624C25.9419 21.0192 26.2499 20.7112 26.2499 20.3317V18.04C26.2499 17.6605 25.9419 17.3525 25.5624 17.3525H23.2708C22.8913 17.3525 22.5833 17.6605 22.5833 18.04V20.3317C22.5833 20.7112 22.8913 21.0192 23.2708 21.0192Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.25 10.019H25.3334V8.18565C25.3334 7.67976 24.9227 7.26904 24.4166 7.26904H23.5C22.9939 7.26904 22.5834 7.67976 22.5834 8.18565V10.019H13.4166V8.18565C13.4166 7.67976 13.0061 7.26904 12.5 7.26904H11.5834C11.0773 7.26904 10.6666 7.67976 10.6666 8.18565V10.019H9.75C8.23384 10.019 7 11.2529 7 12.769V26.519C7 28.0352 8.23384 29.269 9.75 29.269H26.25C27.7662 29.269 29 28.0352 29 26.519V12.769C29 11.2529 27.7662 10.019 26.25 10.019ZM27.1666 26.519C27.1666 27.0241 26.7551 27.4357 26.25 27.4357H9.75C9.24495 27.4357 8.83339 27.0241 8.83339 26.519V16.4724H27.1666V26.519Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoster);
export default __webpack_public_path__ + "static/media/roster.54740a1b89d1508ed6920f3291af049c.svg";
export { ForwardRef as ReactComponent };